import { Badge } from "./Badge"
import { Button } from "./Button"
import { Link } from "./Link"
import { Tag } from "./Tag"
import { Modal } from "./Modal"
import { Checkbox } from "./Checkbox"
import { Tabs } from "./Tabs"

export default {
  Badge,
  Button,
  Link,
  Tag,
  Modal,
  Checkbox,
  Tabs,
}
